/**
 * Environment variables exposed to the application.
 * Loaded via dotenv plugin and react-inject-env for runtime overrides.
 */
export const defaultConfig = {
  NODE_ENV: "local",
  BASE_URL: "pushpresslocal.com",
  API_BASE_URL: "api.pushpresslocal.com",
  TRAIN_BASE_URL: "https://train-dev1.pushpressdev.com",
  USER_SERVICE: "/v2/user",
  APPOINTMENTS_SERVICE: "/v2/appointments",
  BILLING_SERVICE: "/v2/billing",
  AUTH_SERVICE: "/v2/auth",
  ACTIVITY_SERVICE: "/v2/activity",
  CLIENT_SERVICE: "/v2/client",
  SUBSCRIPTION_SERVICE: "/v2/subscription",
  COMMUNICATIONS_SERVICE: "/v2/communications",
  STRIPE_SAAS_PUBLISHABLE_KEY: "pk_test_LcViubJqNEZxphAgjbfkL3wP",
  STRIPE_PAYMENTS_PUBLISHABLE_KEY: "pk_z3pLA3XKNRPUcw5ui0K3szHX8Fjjf",
  SEGMENT_WRITE_KEY: "c93JpKwf3JAvcVNQyZk89fXW3GHJTwXC",
  TRAIN_IOS_APP_LINK:
    "https://apps.apple.com/no/app/train-by-pushpress/id1579588461",
  TRAIN_ANDROID_APP_LINK:
    "https://play.google.com/store/apps/details?id=com.pushpress.train",
  TRAIN_LEARN_MORE_LINK:
    "https://help.pushpress.com/en/articles/5701609-train-sync-members-with-core",
  FULL_CALENDAR_LICENSE_KEY: "0363565530-fcs-1712703116",
  HUBSPOT_ID: "49106097",
  REVENUE_HERO_SAF_ROUTER_ID: 2874,
};

export const env = {
  NODE_ENV: process.env.NODE_ENV,
  // Default config values, overridden by .env and runtime window.env
  API_BASE_URL: process.env.API_BASE_URL ?? defaultConfig.API_BASE_URL,
  TRAIN_BASE_URL: process.env.TRAIN_BASE_URL ?? defaultConfig.TRAIN_BASE_URL,
  USER_SERVICE: process.env.USER_SERVICE ?? defaultConfig.USER_SERVICE,
  APPOINTMENTS_SERVICE:
    process.env.APPOINTMENTS_SERVICE ?? defaultConfig.APPOINTMENTS_SERVICE,
  BILLING_SERVICE: process.env.BILLING_SERVICE ?? defaultConfig.BILLING_SERVICE,
  AUTH_SERVICE: process.env.AUTH_SERVICE ?? defaultConfig.AUTH_SERVICE,
  ACTIVITY_SERVICE:
    process.env.ACTIVITY_SERVICE ?? defaultConfig.ACTIVITY_SERVICE,
  CLIENT_SERVICE: process.env.CLIENT_SERVICE ?? defaultConfig.CLIENT_SERVICE,
  COMMUNICATIONS_SERVICE:
    process.env.COMMUNICATIONS_SERVICE ?? defaultConfig.COMMUNICATIONS_SERVICE,
  SUBSCRIPTION_SERVICE:
    process.env.SUBSCRIPTION_SERVICE ?? defaultConfig.SUBSCRIPTION_SERVICE,
  STRIPE_SAAS_PUBLISHABLE_KEY:
    process.env.STRIPE_SAAS_PUBLISHABLE_KEY ??
    defaultConfig.STRIPE_SAAS_PUBLISHABLE_KEY,
  STRIPE_PAYMENTS_PUBLISHABLE_KEY:
    process.env.STRIPE_PAYMENTS_PUBLISHABLE_KEY ??
    defaultConfig.STRIPE_PAYMENTS_PUBLISHABLE_KEY,
  SEGMENT_WRITE_KEY:
    process.env.SEGMENT_WRITE_KEY ?? defaultConfig.SEGMENT_WRITE_KEY,
  REACT_APP_INTERCOM_APP_ID: process.env.REACT_APP_INTERCOM_APP_ID,
  TRAIN_IOS_APP_LINK:
    process.env.TRAIN_IOS_APP_LINK ?? defaultConfig.TRAIN_IOS_APP_LINK,
  TRAIN_ANDROID_APP_LINK:
    process.env.TRAIN_ANDROID_APP_LINK ?? defaultConfig.TRAIN_ANDROID_APP_LINK,
  TRAIN_LEARN_MORE_LINK:
    process.env.TRAIN_LEARN_MORE_LINK ?? defaultConfig.TRAIN_LEARN_MORE_LINK,
  FULL_CALENDAR_LICENSE_KEY:
    process.env.FULL_CALENDAR_LICENSE_KEY ??
    defaultConfig.FULL_CALENDAR_LICENSE_KEY,
  HUBSPOT_ID: process.env.HUBSPOT_ID ?? defaultConfig.HUBSPOT_ID,
  REVENUE_HERO_SAF_ROUTER_ID:
    process.env.REVENUE_HERO_SAF_ROUTER_ID ??
    defaultConfig.REVENUE_HERO_SAF_ROUTER_ID,
  HEAP_ANALYTICS_APP_ID: process.env.HEAP_ANALYTICS_APP_ID,
  // Runtime overrides from public/env.js
  ...window.env,
};

const nodeEnv = process.env.NODE_ENV
  ? process.env.NODE_ENV.toLowerCase()
  : undefined;

/** Environment check helpers */
export const isLocal = () => ["local"].includes(nodeEnv);
export const isDev = () => ["dev", "development"].includes(nodeEnv);
export const isStage = () => ["stage", "staging"].includes(nodeEnv);
export const isProd = () => ["prod", "production"].includes(nodeEnv);
